import Box from '@mui/material/Box';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { useSnackbar } from 'notistack';
import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { AudienceListType, FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { useDemographicsOptions } from '../../../hooks/useDemographicsOptions.ts';
import { DemographicsAge } from './DemographicsAge.tsx';
import { DemographicsGender } from './DemographicsGender.tsx';

export type DemographicsExpandedProps = {
  listType: AudienceListType;
  isEdit: boolean;
  demographicGenderSegments: FormSegment[];
  setDemographicGenderSegments: Dispatch<SetStateAction<FormSegment[]>>;
  demographicAgeSegments: FormSegment[];
  setDemographicAgeSegments: Dispatch<SetStateAction<FormSegment[]>>;
};

export const DemographicsExpanded = ({
  listType,
  isEdit,
  setDemographicAgeSegments,
  setDemographicGenderSegments,
  demographicGenderSegments,
  demographicAgeSegments,
}: DemographicsExpandedProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, error } = useDemographicsOptions();

  useEffect(() => {
    if (error) {
      enqueueSnackbar(t('Could not load demographics data'), { variant: 'error' });
    }
  }, [t, error, enqueueSnackbar]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Box sx={{ pt: 1 }}>
      <DemographicsGender
        isEdit={isEdit}
        selectedGenderSegments={demographicGenderSegments}
        setSelectedGenderSegments={setDemographicGenderSegments}
      />

      <DemographicsAge
        isEdit={isEdit}
        listType={listType}
        selectedAgeSegments={demographicAgeSegments}
        setSelectedAgeSegments={setDemographicAgeSegments}
      />
    </Box>
  );
};
